import {appsettings} from "../AppSettings";


export default class ConfigService
{


    constructor()
    {
        this.appsettings = appsettings;
    }


    hasKey(key){
        return this.appsettings.some(o => o.key === key);
    }

    getValue(key){
        let obj = this.appsettings.find(o => o.key === key);
        return obj.value;
    }

    getAppPrefix()
    {
        return this.getValue("system.app.prefix");
    }

    getAppVersion()
    {
        return this.getValue("version");
    }

    getAppHost()
    {
        return this.getValue("glasschain.app.host.addr");
    }

    getAuthServiceHost()
    {
        return this.getValue("glasschain.auth.host.addr");
    }

    getAuthResourceServiceHost()
    {
        return this.getValue("glasschain.auth.resource.host.addr");
    }

    getCoreServiceHost()
    {
        return this.getValue("glasschain.core.host.addr");
    }

    getDataApiServiceHost()
    {
        return this.getValue("glasschain.data.api.host.addr");
    }


    getNotificationServiceHost()
    {
        return this.getValue("glasschain.notification.host.addr");
    }


    getAddressServiceHost()
    {
        return this.getValue("glasschain.address.host.addr");
    }

    getTranslationServiceHost()
    {
        return this.getValue("glasschain.translation.host.addr");
    }

    getTextRecognitionServiceHost()
    {
        return this.getValue("google.vision.api.host.addr");
    }

    getWeatherServiceHost()
    {
        return this.getValue("glasschain.weather.host.addr");
    }

    getTranslateServiceHost()
    {
        return this.getValue("glasschain.translate.host.addr");
    }

    getGlasschainCommonImagePath()
    {
        var result = this.getValue("glasschain.image.common.store.addr");
        return result;
    }

    getGlasschainLogoImagePath()
    {
        var result = this.getValue("glasschain.image.store.addr") + "gc-images/";
        return result;
    }

    getCustomerLogoImagePath(gcid)
    {
        // https://gcblobstoredurable1.blob.core.windows.net/gcid/lgs/lgs-logo.png
        var result = this.getValue("glasschain.image.store.addr") +"gcid/" + gcid + "/logos/" + gcid + "-logo.png";
        return result;
    }

    getUserGuideFilePath(gcid)
    {
        var result = this.getValue("userguide.file.addr").replace("{gcid}", gcid) + this.getValue("userguide.file.name");
        return result;
    }

    getBaseUserScope()
    {
        return this.getValue("base.user.scope");
    }

    getDefaultEmailFromAddress()
    {
        return this.getValue("default.email.from.address");
    }

    getWatchInterval()
    {
        return this.getValue("lot.watch.interval.milliseconds");
    }

    // roles we do NOT want to be assigned to users
    getSystemRoles()
    {
        return this.getValue("system.roles");
    }

    // users we do NOT want clients to modify
    getSystemUsers()
    {
        return this.getValue("system.users");
    }

    getSystemLists()
    {
        return this.getValue("system.lists");
    }

    getSystemEntities()
    {
        return this.getValue("system.entities");
    }

    getGeolocationOptions()
    {
        return this.getValue("geolocation.options");
    }

    getFullUid(gcid, uid)
    {
        return uid + "." + this.getAppPrefix() + "." + gcid;
    }
    getShortUid(gcid, uid)
    {
        var uidSuffix = "." + this.getAppPrefix() + "." + gcid;
        var result = uid.replace(uidSuffix, '');
        return result;
    }

    getGcidSlideBasePath(gcid)
    {
        return this.getValue("glasschain.gcid.slide.store.addr") + gcid + "/obs/slides/";
    }

    getGcidUserImageBasePath(gcid)
    {
        return this.getValue("glasschain.gcid.userimg.store.addr") + gcid + "/obs/userimg/";
    }

    getGcidUserDocBasePath(gcid)
    {
        return this.getValue("glasschain.gcid.userdoc.store.addr") + gcid + "/obs/userdoc/";
    }

    getGcidUserRptBasePath(gcid)
    {
        return this.getValue("glasschain.gcid.userrpt.store.addr") + gcid + "/obs/userrpt/";
    }

    getUserRoles()
    {
        return this.getValue("user.roles");
    }

    getDataApiRole()
    {
        return this.getValue("dataApiRole");
    }



    getGoogleVisionApiKey()
    {
        return this.getValue("google.vision.api.key");
    }


}